import * as React from "react"
import { batch } from "@preact/signals-react"

import { AppOfficesAutocomplete } from "@components"
import { disableButton, offices, officesOptions } from "@signals"
import OfficesAutocomplete from "./Offices";


export default function NonAsyncOfficesAutocomplete({ ...props }) {
	return <AppOfficesAutocomplete
		options={officesOptions.value}
		value={offices.value}
		onChange={e => batch(() => {
			disableButton.value = true
			offices.value = e.target.value
		})}
		onFinishAjax={options => {
			offices.value = options.filter(({ selected }) => selected)[0]?.value || options[0].value
		}}
		{...props}
	/>
}
